module.exports = __webpack_public_path__ + "static/media/warning.1965e066.svg";